import React, { useState } from "react";
import { useGet } from "../../common/hooks";
import { Division, Game } from "../../common/interfaces";
import { Button, Divider } from "antd";
import { allKnownDivisions, dtNow, getDivisionName } from "../../common/utils";
import { CompactTable } from "../../common/components/CompactTable";
import { DivisionSelect } from "../../common/components/DivisionSelect";
import { Link, useParams } from "react-router-dom";
import { GoalieAssignUrl } from "../routes";
import { goalieGameColumns } from "../goalieGameColumns";
import _ from "lodash";

export function GoalieAssignmentSeason() {
  const { division: divisionParam } = useParams<{ division?: string }>();
  const initialDivision = allKnownDivisions.find(d => getDivisionName(d).toLowerCase() === divisionParam?.toLowerCase());
  const [division, setDivision] = useState<Division | undefined>(initialDivision);
  // Don't cache: goalie assignments made on GoalieAssign should be reflected immediately on return.
  const games = useGet<Game[]>(division !== undefined ? "/api/games" : undefined, false);

  const upcomingGames = _.sortBy(
    (games.data || []).filter(g => g.date > dtNow() && (!division || g.division === division)),
    g => g.date
  );

  const columns = [
    ...goalieGameColumns,
    {
      key: "assign",
      title: "",
      render: (_: any, row: Game) => (
        <Link to={GoalieAssignUrl.createUrl(row.id)}>
          <Button size="small">Assign Goalies</Button>
        </Link>
      )
    }
  ];

  return (
    <>
      <Divider>Assign Goalies</Divider>
      <DivisionSelect
        value={division}
        onChange={setDivision}
        onClear={() => setDivision(undefined)}
      />
      <CompactTable
        data={upcomingGames}
        columns={columns}
        loading={games.isLoading}
      />
    </>
  );
}
